import { useState } from "react";

const navLinks = [
  { label: "傍晚新料", href: "#focus" },
  { label: "大图爆料", href: "#wall" },
  { label: "前后对比", href: "#compare" },
  { label: "当事人回应", href: "#reply" },
  { label: "网友热议", href: "#talk" },
  { label: "吃瓜时间轴", href: "#timeline" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/80 bg-background-50/90 backdrop-blur">
      <div className="flex h-16 items-center gap-4 px-4 md:h-[72px] md:px-8">
        <a href="#top" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-sun-line text-lg" />
          </span>
          <span className="font-heading text-xl font-semibold tracking-wide text-foreground-950 md:text-[22px]">
            黑料六点
          </span>
          <span className="hidden items-center gap-1.5 rounded-full border border-primary-200 bg-primary-50 px-2.5 py-1 text-xs text-primary-700 sm:flex">
            <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-primary-500" />
            18:00 上新
          </span>
        </a>

        <nav className="hidden flex-1 items-center justify-center gap-0.5 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2 md:gap-3">
          <label className="hidden items-center gap-2 rounded-full border border-background-200 bg-background-100/70 px-3.5 py-2 transition-colors focus-within:border-primary-300 md:flex">
            <span className="flex h-4 w-4 items-center justify-center text-foreground-500">
              <i className="ri-search-line text-base" />
            </span>
            <input
              type="text"
              placeholder="搜今晚的料"
              className="w-28 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none xl:w-40"
            />
          </label>

          <a
            href="#download"
            className="hidden whitespace-nowrap items-center gap-1.5 rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:flex"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-download-2-line text-base" />
            </span>
            下载 App
          </a>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200/80 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <div className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="whitespace-nowrap rounded-md bg-background-100 px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-200"
              >
                {link.label}
              </a>
            ))}
          </div>
          <a
            href="#download"
            onClick={() => setOpen(false)}
            className="mt-3 flex w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-download-2-line text-base" />
            </span>
            下载 App
          </a>
        </div>
      )}
    </header>
  );
}